













































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentIntegrarRepasseUnico extends Vue {
  loadIntegrarRepasseUnico: boolean = false

  get modalIntegrarRepasseUnico() { return this.getFinanceiroStore.modal.integrarRepasseUnico }
  set modalIntegrarRepasseUnico(value: boolean) { this.getFinanceiroStore.setModal({ name: 'integrarRepasseUnico', value }) }

  get loadingIntegrarRepasseUnico() { return this.loadIntegrarRepasseUnico }
  set loadingIntegrarRepasseUnico(value: boolean) { this.loadIntegrarRepasseUnico = value }


  async integrarRepasseUnico() {
    this.loadingIntegrarRepasseUnico = true
    const response: any = await this.getFinanceiroStore.integrarRepasseUnico()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'A integração do repasse foi iniciada!', icon: 'done', color: '#2E7D32' })
      this.modalIntegrarRepasseUnico = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao integrar o repasse.', icon: 'warning', color: '#C62828' })
    }
    this.loadingIntegrarRepasseUnico = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
